let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i0xpP")).then(() => parcelRequire('knTYu'));